import Modal from './Modal';
import DeleteModal from './DeleteModal';
import { ModalPane } from './components';

export default Modal;
export { DeleteModal, ModalPane };
